import React from "react";
import Axios from 'axios'
import MasterTemplate from "./MasterTemplate";
import loading from '../Assets/images/loading.gif';
import moment from 'moment';

export class ExtrairCartelasAvulsas extends React.Component {
  constructor(props) {
    window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("user")),
      gerentes: [],
      isLoading: true,
      gerenteSelecionado: null,
      quantidade: 0,
      series: [],
      generate : false
    };
    this.getGerentes();
    this.getSeries();
    this.setQuantidade = this.setQuantidade.bind(this)
    this.setGerente = this.setGerente.bind(this)
    this.gerarSerie = this.gerarSerie.bind(this)
    this.setGerenteCriarPedidos = this.setGerenteCriarPedidos.bind(this)
  }

  setGerenteCriarPedidos(e){
    localStorage.setItem('gerente', e.target.accessKey);
    this.props.history.push('/criar-pedidos')
  }

  setQuantidade(e){
    this.setState({quantidade : parseInt(e.target.value)})
  }

  setGerente(e){
    console.log(e.target.value)
    this.setState({gerenteSelecionado : JSON.parse(e.target.value)})
  }


  formatDate(data) {
  return moment(data).add(0,'days').format('DD-MM-YYYY')
  }

  getUser = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("usuarios/user", {
        id: this.state.user._id
      });

      window.localStorage.setItem("user", JSON.stringify(response.data[0]));
      this.setState({ user: response.data[0] });
    } catch (err) {
      console.log(err);
    }

  };

  getGerentes = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("usuarios/listar-todos-gerentes", {
        });
        this.setState({gerentes: response.data.sort(this.compararNome)});

    } catch (err) {
        console.log(err);
    }
};

getSeries= async (e) => {
  try {
    var axiosInstance = new Axios.create({
      baseURL: window.localStorage.getItem("apiUrl")
    });
    const response = await axiosInstance.get("series/tipo-serie");
      this.setState({series: response.data, isLoading: false});
  } catch (err) {
      console.log(err);
  }
};

async gerarSerie(){
  this.setState({isLoading: true})
  if(this.state.quantidade == 0){
    alert("Selecione a quantidade de cartelas!")
    window.location.reload(false);
}
  else if(!this.state.gerenteSelecionado){
    alert("Selecione um gerente!")
    window.location.reload()
  }
  if(this.state.quantidade > 0 && this.state.gerenteSelecionado){
  try {
    var axiosInstance = new Axios.create({
      baseURL: window.localStorage.getItem("apiUrl")
    });
    const response = await axiosInstance.post("series/manager-extract", {
         gerenteId: this.state.gerenteSelecionado._id,
         serieLength: parseInt(this.state.quantidade)
      });
    this.setState({isLoading: false})
    alert("Serie gerada com sucesso!")
    window.location.reload()
  } catch (err) {
      console.log(err);
  }
  }
}

compararNome (a, b) {
  if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
    return 1;
  }
  if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
    return -1;
  }

  return 0
}

  render() {
    return (
      <div style={{flex: 1, width: "100%", height: '100%'}}>
      {this.state.isLoading? 
          <div className='sf-modal'>
             <img className='sf-loading' src={loading}></img>
         </div> : ""}
      <MasterTemplate  label="Extrair cartelas">
            <div class="content">
              <div class="container-fluid">
                <div class="row pl-5">
                  <div class="col">
                  <span class="font-weight-bold">Quantidade de cartelas:</span><br/>
                    <select onChange={this.setQuantidade} class="custom-select">
                      <option selected>Nenhum...</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="250">250</option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                    </select>
                  </div>
                  <div class="col">
                  <span class="font-weight-bold">Gerente: </span><br/>
                    <select onChange={this.setGerente} class="custom-select">
                      <option selected>Nenhum...</option>
                      {this.state.gerentes.length > 0 ?this.state.gerentes.map(gerente => {
                         return <option value={JSON.stringify(gerente)}>{gerente.nome}</option>
                      }) :  ""}
                    </select>
                  </div>
                  <div class="col">
                      <button class="mt-4 btn-fill btn btn-primary" onClick={this.gerarSerie}>GERAR</button>
                  </div>
                </div>
                <div class="row pl-5">
                <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Série</th>
                        <th scope="col">Gerente</th>
                        <th scope="col">Não impressas</th>
                        <th scope="col">Data</th>
                        <th scope="col">Download</th>
                        {/* <th scope="col">Criar pedidos</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.series.length > 0? this.state.series.map((serie, index) => {

                        return(
                          <tr accessKey={JSON.stringify(serie.gerenteId)}>
                            <th accessKey={JSON.stringify(serie.gerenteId)} scope="row">{index + 1}</th>
                            <td accessKey={JSON.stringify(serie.gerenteId)}>{serie.gerenteId.nome}</td>
                            <td accessKey={JSON.stringify(serie.gerenteId)}>{serie.cartelas.length}</td>
                            <td accessKey={JSON.stringify(serie.gerenteId)}>{this.formatDate(serie.data)}</td>
                            <td><a href={`${window.localStorage.getItem("apiUrl")}/series/excell/${serie._id}/${serie.gerenteId.nome}.xlsx`}  download="planilha" >download</a></td>
                            {/* <td><button class="btn-fill btn btn-danger" accessKey={JSON.stringify(serie.gerenteId)} onClick={this.setGerenteCriarPedidos}>Criar pedidos</button></td> */}
                          </tr>)
                      }) : ""}

                    </tbody>
                  </table>
                </div>
              </div>
            </div>
        </MasterTemplate>
        </div>
    );
  }
}

export default ExtrairCartelasAvulsas;
